<template>
  <div class="friend">


  </div>
</template>
<script>
  import { Toast } from 'vant';
export default {
  name: 'faceFail',
  computed: {
  },
  methods: {

  },
  mounted() {
    Toast.fail('实名认证失败!')
    setTimeout(()=>{
      uni.postMessage({
        data: {
          action: 'fail'
        }
      })
    },2000)
  }
}

</script>
<style  scoped>

</style>



// WEBPACK FOOTER //
// faceFail.vue?0d983072